import { divideSpoilers } from './divideSpoilers';

const HTML_PARAGRAPH_PATTERN = '<p>((?:.|\n)*?)</p>';

const HTML_PARAGRAPH_REG_EXP_WORD = new RegExp(`^${HTML_PARAGRAPH_PATTERN}$`);

export const wrapTextInParagraphs = (text: string, withSpoiler: boolean) => {
  // если обернут в тег параграфа, удаляем теги
  let str = text.replace(HTML_PARAGRAPH_REG_EXP_WORD, '$1');
  if (withSpoiler) {
    str = divideSpoilers(str);
  }

  const lines = str.split('\n');
  return lines.map((line) => `<p>${line}</p>`).join('');
};
